<agpr-popup-dialog
    id="analysis_upsell_popup"
    class="agpr-analysisUpsellPopup"
    [ngClass]="{
        'agpr-analysisUpsellPopup--light': !isWhiteLabeledBrand,
        'agpr-analysisUpsellPopup--primary': isWhiteLabeledBrand
    }"
    [positionX]="positionX"
    [positionY]="positionY"
    (click)="cancel()"
    (close)="cancel()"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        (click)="setSelf($event)"
        class="agpr-analysisUpsellPopup-container"
    >
        <div class="agpr-analysisUpsellPopup-heading">
            <span class="agpr-analysisUpsellPopup-icon" [ngClass]="icon" aria-hidden="true"></span>
            {{ heading | localize}}
            <agpr-button
                class="agpr-analysisUpsellPopup-focusClose"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-xmark"
                ariaLabel="close"
                (click)="cancel()"
            ></agpr-button>
        </div>
        <div class="agpr-analysisUpsellPopup-content">
            <div class="agpr-analysisUpsellPopup-message">{{ message | localize}}</div>
            <ul class="agpr-analysisUpsellPopup-messageBullets">
                @for(bullet of bullets; track bullet) {
                    <li>{{ bullet | localize}}</li>
                }
            </ul>
            @if (endMessage) {
                <div class="agpr-analysisUpsellPopup-message">{{ endMessage | localize}}</div>
            }
        </div>
        <div class="agpr-analysisUpsellPopup-button">
            <agpr-button
                [id]="'analysis_block_unlock'"
                label="Mention.insights.upsell.unlock"
                [style]="buttonTypes.primary"
                [disabled]="loading"
                (click)="unlock()"
                ariaLabel="Mention.insights.upsell.message.callForAction"
            ></agpr-button>
        </div>
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
</agpr-popup-dialog>
